module.exports = __webpack_public_path__ + "img/Type_Psychic.37ba180b.png";